import React, { useState, useEffect } from "react";
import { Card, CardContent } from "@mui/material";
import { MdHistory } from "react-icons/md";
import Tab from "../../components/Tab";
import { getFleetStatusHistory } from "../../api/fleetStatusApi";
import Grid from "../../components/Grid";
import { IssueStatusCellStyle, ResizableScrollingTextRenderer, DateTimeCellRenderer } from "../../components/renderer/StyleRenderer";
import {getBulkDropdownData} from "../../api/keyvalue";
const WorkOrderStatusManagement = ({ referenceId, referenceCode, close }) => {
    const [tab, setTab] = useState(1);
    const [historyData, setHistoryData] = useState([]);
    const [currentStatus, setCurrentStatus] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const [statusOpt, setStatusOpt] = useState([]);
    const [activeOpt, setActiveOpt] = useState([]);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            const {
                service_status,
                active,
            } = await getBulkDropdownData([
                { key: "service_status" },
                { key: "active" },
            ]);

            setStatusOpt(service_status || []);
            setActiveOpt(active || []);
            console.log("service_status",service_status)
            setIsLoading(false);
        })();
    }, []);
    useEffect(() => {
        const fetchHistory = async () => {
            if (!referenceId) return;
            setIsLoading(true);
            try {
                const data = await getFleetStatusHistory(1, referenceId);
                console.log("getFleetStatusHistory", data)
                setHistoryData(data || []);
                if (data && data.length > 0) {
                    setCurrentStatus(data[data.length - 1]);
                }
            } catch (error) {
                console.error("Failed to fetch history:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchHistory();
    }, [referenceId]);

    const IssueStatusHeader = () => {
        const currentStatusText = statusOpt?.find(
                s => Number(s.value) === currentStatus?.tfsFleetStatus)?.text
            || currentStatus?.rstDescription
            || currentStatus?.tfsStatusText
            || currentStatus?.status
            || currentStatus?.tfsFleetStatus
            || "N/A";

        return (
            <div className="ui segment" style={{ marginBottom: "10px" }}>
                <div className="ui three column grid">
                    <div className="column">
                        <strong>Work Order:</strong> {referenceCode}
                    </div>
                    <div className="column">
                        <strong>Current Status:</strong>{" "}
                        <span
                            style={{
                                backgroundColor: currentStatus?.staColor || currentStatus?.color || "grey",
                                color: "#fff",
                                padding: "3px 10px",
                                borderRadius: "4px",
                            }}
                        >
                            {currentStatusText}
                        </span>
                    </div>
                    <div className="column">
                        <strong>Last Updated:</strong>{" "}
                        {currentStatus?.rstDate || currentStatus?.createdDate
                            ? new Date(currentStatus.rstDate || currentStatus.createdDate).toLocaleString()
                            : "N/A"}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Card>
            <CardContent style={{ height: "80vh", minWidth: "65vw", overflow: "scroll" }}>
                <div className="ui top attached tabular menu">
                    <Tab
                        Icon={MdHistory}
                        onClick={() => setTab(1)}
                        active={tab === 1}
                        label="Status History"
                        authenticated={false}
                    />
                </div>

                <div
                    className="ui bottom attached active tab segment"
                    style={{ display: tab === 1 ? "block" : "none" }}
                >
                    <IssueStatusHeader />
                    <div style={{ marginTop: "20px" }}>
                        <Grid
                            isLoading={isLoading}
                            autoHeight={true}
                            searchable={false}
                            config={[
                                {
                                    headerName: "Order",
                                    field: "index",
                                    width: 80,
                                    sort: "desc",
                                },
                                {
                                    headerName: "Status",
                                    field: "statusText",
                                    width: 180,
                                    cellRenderer: IssueStatusCellStyle,
                                },
                                {
                                    headerName: "Updated By",
                                    field: "updatedBy",
                                    cellRenderer: ResizableScrollingTextRenderer,
                                },
                                {
                                    headerName: "Date",
                                    field: "date",
                                    cellRenderer: DateTimeCellRenderer,
                                },
                            ]}
                            content={historyData.map((item, idx) => ({
                                ...item,
                                index: idx + 1,
                                statusText: statusOpt?.find(s => Number(s.value) === item.tfsFleetStatus)?.text || item.tfsFleetStatus || item.statusText || "N/A",
                                updatedBy: item.updatedBy || item.createdBy || "N/A",
                                date: item.rstDate || item.createdDate || null,
                            }))}
                        />
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};

export default WorkOrderStatusManagement;
